<template>
	<div>
		<ExportSong />
	</div>
</template>

<script>
	import ExportSong from "../components/export/ExportSong";

	export default {
		components: {
			ExportSong
		}
	}
</script>

<style lang="scss">
</style>
